import React, { useEffect, useRef, useState } from "react";

const ImageWithSkeleton = ({ src, alt, className = "", height = "h-48" }) => {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef(null);

  // Reset loaded when src changes and handle cached images
  useEffect(() => {
    setLoaded(false);
    const img = imgRef.current;
    if (!img) return;
    // If browser already has it cached as complete + non-zero size
    if (img.complete && img.naturalWidth !== 0) {
      setLoaded(true);
    }
  }, [src]);

  return (
    <div className={`relative w-full ${height} overflow-hidden rounded-md`}>
      {/* skeleton sits on top while !loaded */}
      {!loaded && (
        <div className="absolute inset-0 bg-gray-300 shimmer rounded-md" />
      )}

      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)} // hide skeleton on error too
        loading="lazy"
        className={`${className} ${
          loaded ? "opacity-100" : "opacity-0"
        } transition-opacity duration-500 ease-out w-full h-full object-cover`}
      />
    </div>
  );
};

export default ImageWithSkeleton;
